/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payer/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BillingCenter from './BillingCenter/index'
import Company from './Company/index'
import MemberID from './MemberID/index'
import Name from './Name/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Payer({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/InsuredTreatments/Content/InsuredTreatment/Content/InsuredTreatmentItem/Payer"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Payer.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-5xK36': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<MemberID
  viewPath={`${viewPath}/MemberID`}
/>
<BillingCenter
  viewPath={`${viewPath}/BillingCenter`}
/>
<Company
  viewPath={`${viewPath}/Company`}
/>
</div>
{children}
</React.Fragment>)
}